/**
 * fetch с жёстким потолком по времени.
 *
 * Без него зависший (а не упавший) бекенд оставляет промис висеть бесконечно:
 * на странице логина это давало вечный экран «Проверка авторизации…» без выхода.
 */
export const DEFAULT_FETCH_TIMEOUT_MS = 10000;

export async function fetchWithTimeout(
  input: RequestInfo | URL,
  init: RequestInit = {},
  timeoutMs: number = DEFAULT_FETCH_TIMEOUT_MS
): Promise<Response> {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await fetch(input, { ...init, signal: controller.signal });
  } finally {
    window.clearTimeout(timeoutId);
  }
}
